import { SET_APPROVAL_PAGE_TYPE, SET_APPROVAL_REQUEST_DATA,SET_COMMENTS, SET_APPROVAL_STATUS, SET_APPROVAL_TYPE } from "@store/types/approvalTypes";

export const setApprovalPageType = (data: any) => {
    return {
        type: SET_APPROVAL_PAGE_TYPE,
        payload: data
    };
};

export const setApprovalRequestData = (data: any) => {
    return {
        type: SET_APPROVAL_REQUEST_DATA,
        payload: data
    };
};


export const setComments = (data: any) => {
    return {
        type: SET_COMMENTS,
        payload: data
    };
};


export const setApprovalType = (approvalType:any) => {
  return {
    type: SET_APPROVAL_TYPE,
    payload: approvalType,
  };
};

export const setApprovalStatus = (approvalStatus:any) => {
    return {
      type: SET_APPROVAL_STATUS,
      payload: approvalStatus,
    };
  };

  